import {
   GRAPHQL_BASE_SERVER_URL_KEY,
   GRAPHQL_SUBSCRIPTION_SERVER_URL_KEY,
   LOGIN_CLIENT_ID,
   REST_BASE_SERVER_URL_KEY,
   SELECTED_ENV_KEY
} from '../constants'

export function setLoginClientId(clientId: string): void {
   window.localStorage.setItem(LOGIN_CLIENT_ID, clientId)
}

export function getLoginClientId(): string | null {
   return window.localStorage.getItem(LOGIN_CLIENT_ID)
}

export function setRestBaseURL(baseUrl: string): void {
   window.localStorage.setItem(REST_BASE_SERVER_URL_KEY, baseUrl)
}

export function getRestBaseURL(): string | null {
   return window.localStorage.getItem(REST_BASE_SERVER_URL_KEY)
}

export function setGraphQLBaseURL(graphQLUrl: string): void {
   window.localStorage.setItem(GRAPHQL_BASE_SERVER_URL_KEY, graphQLUrl)
}

export function getGraphQLBaseURL(): string | null {
   return window.localStorage.getItem(GRAPHQL_BASE_SERVER_URL_KEY)
}

export function setGraphQLSubscriptionURL(graphQLUrl: string): void {
   window.localStorage.setItem(GRAPHQL_SUBSCRIPTION_SERVER_URL_KEY, graphQLUrl)
}

export function getGraphQLSubscriptionURL(): string | null {
   return window.localStorage.getItem(GRAPHQL_SUBSCRIPTION_SERVER_URL_KEY)
}

export function setSelectedEnv(selectedEnv: string): void {
   window.localStorage.setItem(SELECTED_ENV_KEY, selectedEnv)
}

export function getSelectedEnv(): string | null {
   return window.localStorage.getItem(SELECTED_ENV_KEY)
}

export const enableBackendBaseUrlChange = (
   config: Record<string, any>
): boolean =>
   config.ENABLE_BACKEND_BASE_URL_CHANGE === 'true' &&
   config.ENV_NAME !== 'PRODUCTION'
